import { render } from "./listAboutUs.vue?vue&type=template&id=872151ce&scoped=true"
import script from "./listAboutUs.vue?vue&type=script&lang=js"
export * from "./listAboutUs.vue?vue&type=script&lang=js"

import "./listAboutUs.vue?vue&type=style&index=0&id=872151ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872151ce"]])

export default __exports__